import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
    palette: {
        primary: { main: '#f4df9b' },
        mode: 'dark',
    },
    typography: {
        allVariants: {
            fontFamily: 'Abhaya Libre',
        },
    },
});
